<template>
    <div>
        <GridColumnMenuSort :column="column" :sortable="sortable" :sort="sort" @closemenu="closeMenu"
            @sortchange="sortChange" />
        <GridColumnMenuItemGroup>
            <!-- <GridColumnMenuItem :title="'Columns'" :icon-class="'k-i-columns'" @menuitemclick="onMenuItemClick" /> -->
            <GridColumnMenuCheckboxFilter :column="column" :filter="filter" :filterable="filterable"
                :unique-data="uniqueData" :search-box="false" :data-items="items" :expanded="columnsExpanded"
                @filterchange="filterChange" @expandchange="expandChange" @closemenu="closeMenu" :show="columnsExpanded" v-if="columnsExpanded"/>

        </GridColumnMenuItemGroup>
    </div>
</template>
<script>
import {
    GridColumnMenuFilter,
    GridColumnMenuSort,
    GridColumnMenuItemGroup,
    GridColumnMenuItemContent,
    GridColumnMenuItem,
    GridColumnMenuCheckboxFilter 
} from '@progress/kendo-vue-grid';
import { Button } from '@progress/kendo-vue-buttons';

export default {
    props: {
        column: Object,
        sortable: [Boolean, Object],
        sort: {
            type: Array
        },
        filter: Object,
        filterable: Boolean,
        columns: Array,
        uniqueData: {
            type: Boolean,
            default: true
        },
        items:Array
    },
    data() {
        return {
            currentColumns: [],
            columnsExpanded: true,
            filterExpanded: true,
        };
    },
    created() {
        this.$data.currentColumns = this.$props.columns;
    },
    components: {
        'GridColumnMenuSort': GridColumnMenuSort,
        'GridColumnMenuFilter': GridColumnMenuFilter,
        'GridColumnMenuItemGroup': GridColumnMenuItemGroup,
        'GridColumnMenuItemContent': GridColumnMenuItemContent,
        'GridColumnMenuItem': GridColumnMenuItem,
        'kbutton': Button,
        'GridColumnMenuCheckboxFilter': GridColumnMenuCheckboxFilter
    },
    computed: {
        oneVisibleColumn() {
            return this.currentColumns.filter(c => !c.hidden).length === 1;
        }
    },
    methods: {
        handleFocus(e) {
            this.$emit("contentfocus", e);
        },
        onToggleColumn(id) {
            this.currentColumns = this.currentColumns.map((column, idx) => {
                return idx === id ? { ...column, hidden: !column.hidden } : column;
            });
        },
        onReset(event) {
            event.preventDefault();
            const allColumns = this.$props.columns.map(col => {
                return {
                    ...col,
                    hidden: false
                };
            });

            this.currentColumns = allColumns;
            this.onSubmit();
        },
        onSubmit(event) {
            if (event) {
                event.preventDefault();
            }
            this.$emit('filterchange', event);
            this.$emit('closemenu');
        },
        onMenuItemClick() {
            const value = !this.columnsExpanded;
            this.columnsExpanded = value;
            this.filterExpanded = value ? false : this.filterExpanded;
        },
        onFilterExpandChange(value) {
            this.filterExpanded = value;
            this.columnsExpanded = value ? false : this.columnsExpanded;
        },
        expandChange() {
            this.$emit('expandchange');
        },
        closeMenu() {
            this.$emit('closemenu');
        },
        filterChange(newDescriptor, e) {
            this.$emit('filterchange', newDescriptor, e);
        },
        sortChange(newDescriptor, e) {
            this.$emit('sortchange', newDescriptor, e);
        }
    }
}
</script>